import React, { Component } from 'react';

import ReactDOM from 'react-dom';
import Card from 'material-ui/Card';
import CardActions from 'material-ui/Card';
import {CardHeader, CardText} from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import {RadioButtonGroup, RadioButton} from 'material-ui/RadioButton';

import { FormattedMessage, intlShape } from 'react-intl';
import { RadioButtonChecked } from '@material-ui/icons/RadioButtonChecked';


class MetadataInquiry extends Component {
  static contextTypes = {
    intl: intlShape.isRequired,
  }

  state = {
    expanded: true
  };

  handleExpandChange(ex) {
    this.setState({expanded: ex});
  }

  render() {
    const metadataId = this.props.metadataId;
    const metadataField = this.props.metadata[metadataId];
    const hasValue = metadataId in this.props.values;
    const value = hasValue ? this.props.values[metadataId] : null;
    const isMultiple = metadataField.type === 'multiple';

    const items = metadataField.values[this.context.intl.locale].map((text, ix) => {
      const intlMessageId = "metadata." + metadataId + ".values." + ix;
      return <MenuItem checked={isMultiple && hasValue && value.indexOf(ix) > -1} value={ix} key={ix} primaryText={<FormattedMessage
        id={intlMessageId}
      />} />
    });

    const radios = metadataField.values[this.context.intl.locale].map((text, ix) => {
      const intlMessageId = "metadata." + metadataId + ".values." + ix;
      return <RadioButton checked={isMultiple && hasValue && value.indexOf(ix) > -1} value={ix} key={ix}
        label={<FormattedMessage id={intlMessageId} />}
        iconStyle={{color: '#487ba9', fill: '#487ba9', marginRight: '0.6em'}}
      />;
    });

    const selectionRenderer = (values) => {
      return hasValue ? (isMultiple ? values : [values]).map(ix => this.context.intl.formatMessage({
        id: "metadata." + metadataId + ".values." + ix
      })).join(', ')
      : '';
    };
    
    const largeGridStyles = {display:'grid', gridTemplateRows: '1fr 1fr 1fr 1fr 1fr', gridAutoFlow: 'column'};
    const smallGridStyles = {display:'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr'};
    const valueCount = metadataField.values[this.context.intl.locale].length;

    return <Card ref="card"
      expanded={this.state.expanded}
      onExpandChange={(e) => this.handleExpandChange(e)}
      className="inquiry"
      style={{textAlign:'left', display:'inline-block'}}>
      <CardHeader
        actAsExpander={true}
        showExpandableButton={true}
        className={"metadata-inquiry-header" + (hasValue ? ' filled' : '')}
        title={<FormattedMessage
          id={"metadata." + metadataId + ".title"}
        />}
        subtitle={selectionRenderer(value)}
        avatar={<metadataField.icon />}
        titleColor="inherit"
        titleStyle={{fontSize:'105%'}}
        subtitleColor="inherit"
      />
      <CardText expandable={true}>
        <RadioButtonGroup
          name={metadataId}
          valueSelected={value}
          style={valueCount > 5 ? largeGridStyles : smallGridStyles}
          onChange={(e, v) => {
            this.props.onChange(metadataId, v);
            /*
            if (!isMultiple) {
              this.setState({
                expanded: false
              });
            }
            */
          }}>
          {radios}
        </RadioButtonGroup>
        {/*<SelectField
          value={value}
          fullWidth={true}
          multiple={isMultiple}
          hintText={<FormattedMessage
            id={"Supporter.Metadata.PleaseChoose"}
          />}
          hintStyle={{color: 'black'}}
          onChange={(e, ix, v) => {
            this.props.onChange(metadataId, v);

            if (!isMultiple) {
              this.setState({
                expanded: false
              });
            }
          }}
          selectionRenderer={selectionRenderer}
        >
          {items}
        </SelectField>*/}
      </CardText>
    </Card>;
  }
};

export default MetadataInquiry;


// WEBPACK FOOTER //
// ./src/shared/MetadataInquiry.js